import { Login } from './pages/login'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/home'
import userService from './helpers/user.service'
import Header from './components/Header'
import React, { useEffect, useState } from 'react'

function App () {
  const [loggedIn, setLoggedIn] = useState(false)

  useEffect(() => {
    const user = userService.getUser()
    if (user) {
      setLoggedIn(user)
    }
  }, [])

  return (
    <BrowserRouter>
    <Header loggedIn={loggedIn}/>
    <Routes>
      <Route
            path="/visualizador"
            element={!loggedIn
              ? <Login loggedIn={loggedIn} setLoggedIn={setLoggedIn}/>
              : <Home />
            }
          />
    </Routes>
  </BrowserRouter>
  )
}

export default App
